import fetch from '@/utils/fetch';

export function decList(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getDeclarationPolicyByCondition',
        method: 'post',
        data: query
    });
}

export function decRemove(query) {
    return fetch({
        url: '/Sbzc/Sbzc/batchDeleteDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function decEdit(query) {
    return fetch({
        url: '/Sbzc/Sbzc/saveDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function decPredat(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getManagerDeclarationPolicyById',
        method: 'post',
        data: query
    });
}

export function decStatusSet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/updateStatusDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function decTextSave(query) {
    return fetch({
        url: '/Sbzc/Sbzc/savePolicyReleaseContent',
        method: 'post',
        data: query
    });
}

export function decTextGet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getPolicyReleaseContentByCqjSbzcDeclarationPolicyId',
        method: 'post',
        data: query
    });
}

export function decRules(query) {
    return fetch({
        url: '/Sbzc/Sbzc/saveMatchRule',
        method: 'post',
        data: query
    });
}

export function decRulesGet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getMatchRuleByCqjSbzcDeclarationPolicyId',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/declare/declare.js